
import ReactDOM from "react-dom";
import React, { useState, useRef } from "react";
import { PaperBG } from "../kits";
import Kompass from "../components/Kompass";
import { Helmet } from "react-helmet";
import { aboutSchema } from "./utils/AboutSchema";
import BookingModal from "./BookingModal";
import ModalWrapper from "./utils/ModalWrapper";
import MonoButton from "../kits/DesignKit/MonoButton";
import CardBox from "./CardBox";
import HowItWorks_small from "../components/HowItWorks_small";

const About = () => {
  const [showBooking, setShowBooking] = useState(false);
  const bookingRef = useRef(null);

const handleOpenBooking = () => {
  window.scrollTo({ top: 0 , behavior: "instant" });
  setShowBooking(true);
};

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>
      </Helmet>

      <PaperBG>
        <section id="overview" className="max-w-3xl mx-auto px-6 pt-24 pb-10">
          <div className="text-center" data-aos="fade-up">
            <img
              src={`${process.env.PUBLIC_URL}/images/denis.svg`}
              alt="Denis Bitter"
              className="w-full max-w-[180px] md:max-w-[220px] h-auto mx-auto mb-6"
            />
          </div>

          <div className="text-center text-gray-900 font-mono space-y-1">
            <h1 className="text-xl tracking-tight">Denis Bitter</h1>
            <p className="text-xs md:text-sm">
              Software Architect & Full-Stack Engineering Instructor
            </p>
            <p className="text-xs md:text-sm">
              React · Angular · Flutter · UI Engineering · System Architecture
            </p>
          </div>
        </section>

        {/* FOKUS & WIE ICH ARBEITE */}
        <section className="max-w-3xl mx-auto px-4 py-10 space-y-6">
          <CardBox
            title="Mein Fokus"
            subtitle="praxisnah – menschlich – skalierbar"
            className="text-center text-xs"
          >
            Software, die funktioniert UND verstanden wird.  
            Ich entwickle Systeme, die den Alltag vereinfachen,  
            Teams befähigen und Organisationen voranbringen.
          </CardBox>

          <CardBox
            title="Wie ich arbeite"
            subtitle="klar – strukturiert – in Verantwortung"
            className="text-center text-xs"
          >
            Ich übersetze komplexe Anforderungen in performante Lösungen  
            und ermögliche Teams, sicher und souverän damit zu arbeiten.
          </CardBox>
        </section>

        {/* Bewertung */}
        <section id="referenzen">
          <HowItWorks_small />
        </section>

        {/* CTA */}
        <section
          ref={bookingRef}
          className="flex items-center justify-center w-full py-12 px-6"
        >
          <MonoButton
            className="w-full max-w-xs text-xs"
            onClick={handleOpenBooking}
          >
            Lass uns gemeinsam starten
          </MonoButton>
        </section>

        {/* KOMPASS */}
        <section id="kompass" className="max-w-5xl mx-auto px-6 py-16">
          <Kompass />
        </section>

        {/* ✅ Modal fix – jetzt wie in Navbar */}
{/* ✅ Modal fix – jetzt wirklich wie ein echtes Modal */}
{showBooking &&
  ReactDOM.createPortal(
    <ModalWrapper onClose={() => setShowBooking(false)}>
      <BookingModal onClose={() => setShowBooking(false)} />
    </ModalWrapper>,
    document.getElementById("modal-root") // ✅ instead of body
  )
}

        {/* ABOUT TEXTBLOCK */}
        <section className="w-full py-16 px-6">
          <CardBox className="text-center">
            <p className="text-xs md:text-xs leading-relaxed">
              Ich kombiniere Softwareentwicklung, Architektur und Tech-Education –  
              mit Erfahrung aus über <strong>50+ Projekten</strong> und{" "}
              <strong>500+ Trainings</strong>. <br />
              Für Lösungen, die skalieren. Für Teams, die wachsen. Für Menschen, die verstehen.
            </p>
          </CardBox>
        </section>
      </PaperBG>
    </>
  );
};

export default About;
